import { request } from "utils/api";
import { RequestResponse } from "utils/base_api";

export function index(): Promise<RequestResponse> {
  return request(`/institutions`, { method: "GET" });
}

export function get(institution: string): Promise<RequestResponse> {
  return request(`/institutions/${institution}`, { method: "GET" });
}
